export const FETCH_MAP_CITIES_REQUEST = 'FETCH_MAP_CITIES_REQUEST'
export const FETCH_MAP_CITIES_SUCCES = 'FETCH_MAP_CITIES_SUCCES'
export const FETCH_MAP_CITIES_ERROR = 'FETCH_MAP_CITIES_ERROR'



// WEBPACK FOOTER //
// ./src/constants/Map.js